
import {HiOutlineMagnifyingGlass } from "react-icons/hi2";

const SearchBox = ({onHandleChangeSearch}) => {
    return (
        <div className="flex w-full gap-0 hover:shadow-md rounded-xl rounded-tr-md">
            <span className="bg-green3/25 p-2 rounded-xl rounded-tr-md ">
            <HiOutlineMagnifyingGlass className="w-6 h-6 stroke-green4"/>
            </span>
            {/* <input id="txtSearch" onChange={onHandleChangeSearch} placeholder="Buscar Kit" className="bg-white w-full rounded-xl rounded-tr-md px-3 border-white" type="text" /> */}
        </div>
    );
}

export default SearchBox;